import { commonMessages } from '@common/intl'
import { Alert, AlertTitle, IconButton, Typography } from '@mui/material'
import type React from 'react'
import { useState } from 'react'
import { useIntl } from 'react-intl'

import type { NotificationProps } from '.'
import { messages } from './messages'
import * as S from './styles'

export const Notification: React.FC<NotificationProps> = ({
  onClose,
  title,
  type,
  action,
  content,
  apiMessage,
}) => {
  const [isApiMessageVisible, setIsApiMessageVisible] = useState(false)
  const intl = useIntl()

  const displayTitle =
    apiMessage && !title ? intl.formatMessage(commonMessages.somethingWentWrong) : title

  return (
    <Alert severity={type} onClose={onClose} data-test="notification" data-test-type={type}>
      {displayTitle ? <AlertTitle>{displayTitle}</AlertTitle> : null}
      {content ? <Typography variant="body1">{content}</Typography> : null}
      {isApiMessageVisible ? (
        <S.ApiMessage variant="body2">
          <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{apiMessage}</pre>
        </S.ApiMessage>
      ) : null}
      {action ? (
        <S.ActionButton size="small" onClick={action.onClick} data-test="button-action">
          {action.label}
        </S.ActionButton>
      ) : null}
      {apiMessage ? (
        <S.ApiMessageAction>
          <Typography variant="body1">
            {isApiMessageVisible
              ? intl.formatMessage(messages.hideError)
              : intl.formatMessage(messages.seeError)}
          </Typography>
          <IconButton
            aria-label={isApiMessageVisible ? 'shrink' : 'expand'}
            onClick={() => setIsApiMessageVisible((v) => !v)}
          >
            <S.ExpandIcon isRotated={isApiMessageVisible} />
          </IconButton>
        </S.ApiMessageAction>
      ) : null}
    </Alert>
  )
}

Notification.displayName = 'Notification'
export default Notification
